export class DoughnutChartItem {
    name: string;
    count: number;
    color: string;
    returns: number;
    // showAmounts: boolean;
    // showReturns: boolean;
    constructor(name: string, count: number, color: string, returns: number) {
        this.name = name;
        this.count = count;
        this.color = color;
        this.returns = returns;
        // this.showAmounts = showAmounts;
        // this.showReturns = showReturns;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/doughnut-chart/dought-item.ts